// Meoks: hover'da renk kardeşi sayfasını prefetch et (anında geçiş)
(function () {
  var prefetched = {};
  function prefetch(href) {
    if (!href || prefetched[href]) return;
    prefetched[href] = true;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = href;
    document.head.appendChild(link);
  }
  function bindHover() {
    document.querySelectorAll('.meoks-color-sibling[href], .meoks-card-colors__swatch[href]').forEach(function (a) {
      if (a.dataset.pf) return;
      a.dataset.pf = '1';
      var t;
      a.addEventListener('mouseenter', function () { t = setTimeout(function () { prefetch(a.href); }, 80); });
      a.addEventListener('mouseleave', function () { clearTimeout(t); });
      a.addEventListener('touchstart', function () { prefetch(a.href); }, { passive: true });
      // Garantili navigasyon: tıklama event'i propagate edilmeden direkt yönlendir
      a.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.stopPropagation();
        e.preventDefault();
        window.location.href = a.href;
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindHover); else bindHover();
  var pending = false;
  function schedule() {
    if (pending) return; pending = true;
    (window.requestIdleCallback || window.requestAnimationFrame)(function () { pending = false; bindHover(); });
  }
  var target = document.querySelector('.product-grid, results-list, main') || document.body;
  new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
})();

(function () {
  var KEY = 'meoks_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('meoks:wishlist:changed', { detail: { list: list } }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    write(list);
    return list.indexOf(handle) !== -1;
  }
  function remove(handle) {
    var list = read().filter(function (h) { return h !== handle; });
    write(list);
  }

  function syncButtons() {
    document.querySelectorAll('[data-meoks-wishlist-btn]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      btn.classList.toggle('is-active', has(handle));
      btn.setAttribute('aria-pressed', has(handle) ? 'true' : 'false');
    });
  }
  function syncCount() {
    var n = read().length;
    document.querySelectorAll('[data-meoks-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  function bind() {
    document.querySelectorAll('[data-meoks-wishlist-btn]').forEach(function (btn) {
      if (btn.dataset.inited) return;
      btn.dataset.inited = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle(btn.getAttribute('data-handle'));
        syncButtons();
        syncCount();
      });
    });
  }

  document.addEventListener('meoks:wishlist:changed', function () {
    syncButtons();
    syncCount();
  });

  function init() { bind(); syncButtons(); syncCount(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  // Re-bind after dynamic theme updates (Horizon swaps content) — debounced + scoped
  var rebindPending = false;
  var moTarget = document.querySelector('.product-grid, results-list, main') || document.body;
  var mo = new MutationObserver(function () {
    if (rebindPending) return; rebindPending = true;
    (window.requestIdleCallback || window.requestAnimationFrame)(function () { rebindPending = false; bind(); syncButtons(); });
  });
  mo.observe(moTarget, { childList: true, subtree: true });

  window.MeoksWishlist = { read: read, has: has, toggle: toggle, remove: remove };
})();
